/*
 * @Description: 应用程序框架页面配套js
 * @Author: laoliu
 * @Date: 2021-01-17 22:43:52
 * @LastEditTime: 2023-12-18 11:23:46
 */
import Vue from 'vue'
Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import qs from 'qs'; //请求参数转换
Vue.prototype.qs = qs;

import pinyin from 'js-pinyin'
Vue.prototype.pinyin = pinyin

import echarts from 'echarts'
Vue.prototype.echarts = echarts

import App from './App'
import router from './router'

import '@/assets/common.css'
import Constant, { URL_RETRIEVE_PUBLIC_NOTICE, BASE_URL } from '@/global/Constant.js'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: '@/assets/tbm.png',
    attempt: 1,
    listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove']
})

import commonVue from 'tjzh-common-vue'
Vue.use(commonVue, { baseUrl: BASE_URL })
//全局变量,当前登录的类型,用于当是机构登录时,每个列表页面根据这个显示过滤条件第一项
Vue.prototype.globalData = {
    adminType: ''
}
let vueInstance = new Vue({
    data() {
        return {
            windowWidth: window.innerWidth, //浏览器窗口宽度
            windowHeight: window.innerHeight, //浏览器窗口高度
            contentWidth: 0, //主体区域（app-content)宽度
            contentHeight: 0, //主体区域（app-content)高度
        }
    },
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    render: h => h(App)
})

import smCrypto from 'sm-crypto';
import jsRsasign from 'jsrsasign';
commonVue.initEncryptionUtil(smCrypto, jsRsasign);

/*
 * @Description: AppAxios的"2012(未登录)"回调函数
 * @Author: liusheng
 * @Date: 2021-04-08 10:27:31
 * @param {object} vue Vue实例
 * @param {string} url 接口的请求地址
 * @return {boolean} true/false-通知AppAxios是否显示toast
 */
let notLoginCallback = function(vue, _url) {
    let loginRouterParams = [Constant.SESSION_ADMIN_TYPE, Constant.SESSION_IDENTIFIER];
    let params = {};
    let isInstSelfReg = false;

    loginRouterParams.forEach((item) => {
        params[item] = sessionStorage.getItem(item);
        if (sessionStorage.getItem(item) == Constant.FLAG_INST_SELF_REG) {
            isInstSelfReg = true;
        }
    })

    let routerName = !isInstSelfReg ? 'login' : 'instadminreg';
    vue.$router.push({ name: routerName, params: params });
    return isInstSelfReg;
}

commonVue.initAppAxios(vueInstance, notLoginCallback, router, URL_RETRIEVE_PUBLIC_NOTICE);
commonVue.initVueRequest(vueInstance, notLoginCallback, router, URL_RETRIEVE_PUBLIC_NOTICE);

export default vueInstance


// WEBPACK FOOTER //
// ./src/main.js